export const endpoint = `${import.meta.env.VITE_UAL_API_PROTOCOL}://${
  import.meta.env.VITE_UAL_API_HOST
}${import.meta.env.VITE_UAL_API_PORT ? ':' : ''}${
  import.meta.env.VITE_UAL_API_PORT
}`
export const appName = import.meta.env.VITE_UAL_APP_NAME || 'app'
export const network = {
  chainId: import.meta.env.VITE_UAL_CHAIN_ID,
  rpcEndpoints: [
    {
      blockchain: 'eos',
      protocol: import.meta.env.VITE_UAL_API_PROTOCOL,
      host: import.meta.env.VITE_UAL_API_HOST,
      port: parseInt(import.meta.env.VITE_UAL_API_PORT)
    }
  ]
}
